import Age from '../Steps/Age/Age';
import BodyType from '../Steps/BodyType/BodyType';
import Email from '../Steps/Email/Email';
import Gender from '../Steps/Gender/Gender';
import Relationship from '../Steps/Relationship/Relationship';
import Username from '../Steps/Username/Username';
import ZipCode from '../Steps/ZipCode/ZipCode';

const data = [
  {
    component: Gender,
    percent: 0,
  },
  {
    component: Relationship,
    percent: 10,
  },
  {
    component: Age,
    percent: 20,
    field: 'age',
  },
  {
    component: BodyType,
    percent: 40,
  },
  {
    component: ZipCode,
    percent: 60,
    field: 'zip_code',
  },
  {
    component: Username,
    percent: 80,
    field: ['username', 'password'],
  },
  {
    component: Email,
    percent: 100,
    field: 'email',
  },
];

export default data;
